import React from 'react';
import {
    Button,
    Card,
    CardBody,
    CardSubtitle,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row
} from 'reactstrap';
import AttributesList from '../AttributesList/AttributesList';
import {I18n} from '../../I18n/components/users';
import {USER_ROLES} from '../../helpers/constants';

import profilephoto from '../../assets/images/users/1.jpg';
import MultipleSelect from "../Common/MultipleSelect";

const UserModal = props => {
    const selectedCompany = props.companies.find(company => company.id == props.newUser.companyId);
    const isVisibleSalesPointsSelectVisible = selectedCompany && selectedCompany.types.includes('OPERATOR');
    return (
        <Modal className="user-modal" isOpen={props.isModal} toggle={props.toggle}>
            <ModalHeader toggle={props.toggle}>{I18n[props.lang].modal.add_edit_user}</ModalHeader>
            <ModalBody>
                <Row>
                    <Col xs="12" md="12" lg="3">
                        <Card>
                            <CardBody>
                                <div className="text-center mt-4">
                                    <img src={profilephoto} className="rounded-circle" width="150" alt="" />
                                    <CardTitle className="mt-2 user-modal__name">{props.newUser.name}</CardTitle>
                                    <CardSubtitle>{USER_ROLES[props.newUser.role] || 'none'}</CardSubtitle>
                                </div>
                            </CardBody>
                            <CardBody className="border-top">
                                <div>
                                    <small className="text-muted">{I18n[props.lang].modal.email}</small>
                                    <h6>{props.newUser.email}</h6>
                                    {/*<small className="text-muted pt-4 db">Phone</small>*/}
                                    {/*<h6>+91 654 784 547</h6>*/}
                                    {/*<small className="text-muted pt-4 db">Social Profile</small>*/}
                                    {/*<br/>*/}
                                    {/*<Button className="btn-circle" color="info"><i className="fab fa-facebook-f"></i></Button>{' '}*/}
                                    {/*<Button className="btn-circle" color="success"><i className="fab fa-twitter"></i></Button>{' '}*/}
                                    {/*<Button className="btn-circle" color="danger"><i className="fab fa-youtube"></i></Button>*/}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xs="12" md="12" lg="9">
                        <Card>
                            <CardBody>
                                <Form onSubmit={props.handleSubmit} className='new-user__form'>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            <Input type="hidden" name="id" id="id" defaultValue={props.newUser.id} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup>
                                                <Label for="email">{I18n[props.lang].modal.mail_login}</Label>
                                                <Input
                                                    type="text"
                                                    name="email"
                                                    id="email"
                                                    defaultValue={props.newUser.email}
                                                    onChange={props.onInputChange}
                                                    disabled={props.editMode}
                                                    required={!props.editMode}
                                                />
                                                {props.showErrors('email')}
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup>
                                                <Label for="phoneNumber">{I18n[props.lang].modal.phoneNumber}</Label>
                                                <Input
                                                    type="text"
                                                    name="phoneNumber"
                                                    id="phoneNumber"
                                                    defaultValue={props.newUser.phoneNumber}
                                                    onChange={props.onInputChange}
                                                />
                                                {props.showErrors('phoneNumber')}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup>
                                                <Label for="name">{I18n[props.lang].modal.name}</Label>
                                                <Input
                                                    type="text"
                                                    name="name"
                                                    id="name"
                                                    defaultValue={props.newUser.name}
                                                    onChange={props.onInputChange}
                                                    required
                                                />
                                                {props.showErrors('name')}
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup>
                                                <Label for="companyName">{I18n[props.lang].modal.companyName}</Label>
                                                {
                                                    props.companies.length === 1 ? (
                                                        <Input
                                                            type="text"
                                                            name="companyId"
                                                            id="companyId"
                                                            defaultValue={props.companies[0].name}
                                                            onChange={props.onInputChange}
                                                            disabled
                                                        />
                                                    ) : (
                                                        <Input
                                                            type="select"
                                                            name="companyId"
                                                            id="companyId"
                                                            defaultValue={props.newUser.companyId}
                                                            onChange={props.onInputChange}
                                                            required
                                                        >
                                                            <option value=""></option>
                                                            {
                                                                props.companies ? (
                                                                    props.companies.map((company, i) => {
                                                                        return (
                                                                            <option value={company.id} key={i}>{company.name}</option>
                                                                        )
                                                                    })
                                                                ) : (
                                                                    <option></option>
                                                                )
                                                            }
                                                        </Input>
                                                    )
                                                }
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup>
                                                <Label for="password">{I18n[props.lang].modal.passwd}</Label>
                                                <Input
                                                    type="password"
                                                    placeholder=""
                                                    name="password"
                                                    id="password"
                                                    required
                                                    value={props.newUser.password}
                                                    onChange={props.onInputChange}
                                                    disabled={props.editMode || props.newUser.defaultPassword}
                                                />
                                                {props.showErrors('password')}
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup>
                                                <Label for="repeatPassword">{I18n[props.lang].modal.repeatPassword}</Label>
                                                <Input
                                                    type="password"
                                                    placeholder=""
                                                    name="repeatPassword"
                                                    id="repeatPassword"
                                                    required
                                                    value={props.newUser.repeatPassword}
                                                    onChange={props.onInputChange}
                                                    disabled={props.editMode || props.newUser.defaultPassword}
                                                />
                                                {props.showErrors('repeatPassword')}
                                                {props.showErrors('isPasswordEqual')}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup>
                                                <Label for="status">{I18n[props.lang].modal.status}</Label>
                                                <Input
                                                    type="select"
                                                    name="status"
                                                    id="status"
                                                    defaultValue={props.newUser.status}
                                                    required
                                                    onChange={props.onInputChange}
                                                >
                                                    <option value=""></option>
                                                    <option value="NOT_APPROVED">{I18n[props.lang].modal.statusPending}</option>
                                                    <option value="ACTIVE">{I18n[props.lang].modal.statusActive}</option>
                                                    <option value="BLOCKED">{I18n[props.lang].modal.statusBlocked}</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12" md="12" lg="6">
                                            <FormGroup>
                                                <Label for="role">{I18n[props.lang].modal.chooseRole}</Label>
                                                {
                                                    props.roles.length === 1  ? (
                                                        <Input
                                                            type="text"
                                                            name="role"
                                                            id="role"
                                                            defaultValue={USER_ROLES[props.roles[0]] || 'none'}
                                                            onChange={props.onInputChange}
                                                            disabled
                                                        />
                                                    ) : props.roles.length === 0 ? (
                                                        <Input
                                                            type="text"
                                                            name="role"
                                                            id="role"
                                                            defaultValue={'none'}
                                                            onChange={props.onInputChange}
                                                            disabled
                                                        />
                                                    ) : (
                                                        <Input
                                                            type="select"
                                                            name="role"
                                                            id="role"
                                                            defaultValue={props.newUser.role}
                                                            onChange={props.onInputChange}
                                                            required
                                                        >
                                                            <option value=""></option>
                                                            {
                                                                props.roles ? (
                                                                    props.roles.map((role, i) => {
                                                                        return (
                                                                            <option value={role} key={i}>{USER_ROLES[role]}</option>
                                                                        )
                                                                    })
                                                                ) : (
                                                                    <option></option>
                                                                )
                                                            }
                                                        </Input>
                                                    )
                                                }
                                            </FormGroup>
                                        </Col>
                                        {
                                            isVisibleSalesPointsSelectVisible
                                                ? (
                                                    <Col xs="12" md="12" lg="12">
                                                        <FormGroup>
                                                            <Label for="visibleSalesPointIds">
                                                                {I18n[props.lang].visibleSalesPoints}
                                                            </Label>
                                                            <MultipleSelect
                                                                name="visibleSalesPointIds"
                                                                selectedElementIds={props.newUser.visibleSalesPointIds}
                                                                elements={props.tinyStoresWithOperator}
                                                                onChange={props.onChangeVisibleSalesPoints}
                                                            />
                                                            {props.showErrors('visibleSalesPointIds')}
                                                        </FormGroup>
                                                    </Col>
                                                ) : null
                                        }
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12" lg="12">
                                            {/*<CustomInput*/}
                                            {/*    name="changePasswdCheckbox"*/}
                                            {/*    className="changePasswdCheckbox"*/}
                                            {/*    type="checkbox"*/}
                                            {/*    id="changePasswdCheckbox"*/}
                                            {/*    label={I18n[props.lang].modal.needToPasswdChange}*/}
                                            {/*    checked={props.newUser.defaultPassword}*/}
                                            {/*    onChange={props.onChangePasswd}*/}
                                            {/*/>*/}
											<Button
												color="primary"
												type="button"
												onClick={props.onChangePasswd}
												disabled={!props.editMode || props.defaultPasswordChecked}
											>{I18n[props.lang].modal.resetPassword}</Button>
                                        </Col>
                                    </Row>
                                    {
                                        props.editMode &&
                                        props.newUser.attributes && props.newUser.attributes.length ? "" : (
                                            <Row>
                                                <Col xs="12" md="12" lg="12">
                                                    <FormGroup className='new-attr__buttons'>
                                                        <Button color="secondary" className="ml-1" onClick={props.toggle}>{I18n[props.lang].modal.cancel}</Button>
                                                        <Button color="primary" type="submit" disabled={props.isSaveDisable}>{I18n[props.lang].modal.save}</Button>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                </Form>
                                {
                                   props.editMode &&
                                    props.newUser.attributes && props.newUser.attributes.length ? (
                                        <div className="user__attributes">
                                            <CardSubtitle>{I18n[props.lang].modal.userAttributes}</CardSubtitle>
                                            <AttributesList
                                                attributes={props.newUser.attributes ? props.newUser.attributes : []}
                                                isAttributesChangingAllowed={true}
                                                updateAttributesList={props.updateUserAttributesList}
                                                authority={props.authority}
                                                closeModal={props.toggle}
                                            />
                                        </div>
                                    ) : ""
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    )
};

export default UserModal;



// WEBPACK FOOTER //
// ./src/components/Users/UserModal.js